import React, { Component } from "react";
import { connect } from "react-redux";
import localization from "../../Localization/Localization.json";
import "./Home.scss";
import {
  FaCommentDots,
  FaArchive,
} from "react-icons/fa";
import { FiTrendingUp } from "react-icons/fi";
import FinanceChart from "../../components/FinanceChart/FinanceChart";
import { Link, Redirect  } from "react-router-dom";

class Home extends Component {
  state = {
    homeCard: [
      {
        name: "مجموع الطلبات",
        value: 33,
      },
    ],
  };
  componentDidMount() {
    if(true){
      <Redirect to="/orders" />
    }
    this.props.history.push("/orders")
  }
  
  render() {
    const { currentLang } = this.props;
    return (
      <div className="home-wrapper">
        <div className="container">
          <div className="home-content">
            <h1 className="page-title">{localization.home[currentLang]}</h1>
            <div className="home-cards-wrapper">
              
              <div className="home-card-holder">
                <div className="home-card-top">
                  <div className="card-info">
                    <p className="card-title">
                      {localization.Totalorders[currentLang]}
                    </p>
                    <h4 className="card-value">223</h4>
                  </div>
                  <div className="card-icon">
                    <FaArchive /> 
                  </div>
                </div>
                <div className="home-card-bottom">
                  <FiTrendingUp />
                  <p>%4.3</p>
                  <time>منذ اسبوع</time>
                </div>
              </div>

              <Link to="/orders/1" className="home-card-holder">
                <div className="home-card-top">
                  <div className="card-info">
                    <p className="card-title">
                      {localization.MyOrders[currentLang]}
                    </p>
                    <h4 className="card-value">223</h4>
                  </div>
                  <div className="card-icon" style={{ backgroundColor : "#E6F6F9"}}>
                    <FaCommentDots style={{fill : "#06ACCC"}} />
                  </div>
                </div>
                <div className="home-card-bottom">
                  <FiTrendingUp />
                  <p>%4.3</p>
                  <time>منذ اسبوع</time>
                </div>
              </Link> 
            </div>
            
            <FinanceChart />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang: state.user.currentLang,
});

//   const LoginWithRouter = withRouter(Login);
export default connect(mapStateToProps)(Home);
